var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListChecks = function SvgListChecks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.606 14.576a.6.6 0 1 1 .847.848l-4 4a.6.6 0 0 1-.847 0l-2-2a.599.599 0 1 1 .847-.848l1.577 1.576zM21.03 18.4a.6.6 0 1 1 0 1.2h-8a.6.6 0 1 1 0-1.2zm0-7a.6.6 0 1 1 0 1.2h-8a.6.6 0 1 1 0-1.2zM8.606 4.576a.599.599 0 1 1 .847.848l-4 4a.6.6 0 0 1-.847 0l-2-2a.599.599 0 1 1 .847-.848L5.03 8.152zM21.03 4.4a.6.6 0 1 1 0 1.2h-8a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgListChecks;